import { parseOrder } from 'src/utils'

import { CartProductItem } from '../../types'

/**
 * Parâmetros para {@link parseEvent}
 */
export type UpdateCart = {
  type: 'addItem' | 'removeItem' | 'deleteProduct'
  product: CartProductItem
  position?: number
}

const removeEvent = {
  event: 'removeFromCart',
  'event-category': 'removeFromCart',
  'event-action': 'click',
  'event-label': 'remover-do-pedido',
}

export const parseEvent = ({ type, product, position }: UpdateCart) =>
  ({
    addItem: {
      event: 'addToCart',
      'event-category': 'addToCart',
      'event-action': 'click',
      'event-label': 'adicionar-ao-pedido',
      ecommerce: {
        currencyCode: 'BRL',
        add: {
          products: [{ ...parseOrder(product, position), quantity: 1 }],
        },
      },
      quantity: 1,
    },
    removeItem: {
      ...removeEvent,
      ecommerce: {
        remove: {
          products: [{ ...parseOrder(product, position), quantity: 1 }],
        },
      },
    },
    deleteProduct: {
      ...removeEvent,
      ecommerce: {
        remove: {
          products: [parseOrder(product, position)],
        },
      },
    },
  })[type]
